var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddMyEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddMyEvent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.22701845,5.30001831 L9.00800513,2.51902837 C9.26399829,2.2630349 9.26399829,1.84798856 9.00800513,1.59203172 C8.75201196,1.33603826 8.33700273,1.33603826 8.08100957,1.59203172 L5.29998627,4.37305829 L2.51896297,1.5919951 C2.2629698,1.33600163 1.84796057,1.33600163 1.59196741,1.5919951 C1.33601086,1.84798856 1.33601086,2.2630349 1.59196741,2.51899175 L4.37299071,5.29998169 L1.59196741,8.08100825 C1.33601086,8.33700172 1.33601086,8.75204806 1.59196741,9.0080049 C1.84796057,9.26399837 2.2629698,9.26399837 2.51896297,9.0080049 L5.29998627,6.22697834 L8.08100957,9.0080049 C8.33696611,9.26399837 8.75201196,9.26399837 9.00800513,9.0080049 C9.26399829,8.75201144 9.26399829,8.33700172 9.00800513,8.08100825 L6.22701845,5.30001831 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icAddMyEvent",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(5.300000, 5.300000) rotate(-44.000000) translate(-5.300000, -5.300000) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddMyEvent);
export default __webpack_public_path__ + "static/media/icAddMyEvent.1aeeba8bac9b5e9bd589945f6c4a6aba.svg";
export { ForwardRef as ReactComponent };